export default "__VITE_ASSET__CAs7BJS5__"